// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  font-weight: 600;
}

.burger-wrapper {
  position: relative;
}

.burger-btn {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  font-size: 1.8rem;
  color: #fff;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: transform 0.25s;
  z-index: 60;
}
.burger-btn.open {
  transform: rotate(90deg);
}

.menu {
  position: absolute;
  top: 48px;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 160px;
  padding: 8px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  -webkit-backdrop-filter: blur(14px);
          backdrop-filter: blur(14px);
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.45);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-10px);
  transition: opacity 0.25s, transform 0.25s;
}
.menu.open {
  opacity: 1;
  pointer-events: all;
  transform: translateY(0);
  z-index: 10000;
}

.menu-btn {
  width: 100%;
  padding: 10px 14px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: left;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s;
}
.menu-btn:hover {
  background: rgba(255, 255, 255, 0.14);
}`, "",{"version":3,"sources":["webpack://./src/components/BurgerMenu/BurgerMenu.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WApBI;EAqBJ,uBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,WAAA;AAHF;AAKE;EACE,wBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,qCA5CS;EA6CT,mCAAA;UAAA,2BAAA;EACA,0CAAA;EACA,UAAA;EACA,oBAAA;EACA,4BAAA;EACA,0CAAA;AAJF;AAME;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;AAJJ;;AAQA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WA/DI;EAgEJ,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AALF;AAOE;EACE,qCAzEI;AAoER","sourcesContent":["$bg-glass: rgba(255, 255, 255, 0.08);\n$hover: rgba(255, 255, 255, 0.14);\n$txt: #fff;\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  font-weight: 600;\n}\n\n.burger-wrapper {\n  position: relative;\n}\n\n.burger-btn {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  font-size: 1.8rem;\n  color: $txt;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.25s;\n  z-index: 60;\n\n  &.open {\n    transform: rotate(90deg);\n  }\n}\n\n.menu {\n  position: absolute;\n  top: 48px;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 160px;\n  padding: 8px;\n  border-radius: 16px;\n  background: $bg-glass;\n  backdrop-filter: blur(14px);\n  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.45);\n  opacity: 0;\n  pointer-events: none;\n  transform: translateY(-10px);\n  transition: opacity 0.25s, transform 0.25s;\n\n  &.open {\n    opacity: 1;\n    pointer-events: all;\n    transform: translateY(0);\n    z-index: 10000;\n  }\n}\n\n.menu-btn {\n  width: 100%;\n  padding: 10px 14px;\n  background: transparent;\n  border: none;\n  color: $txt;\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-align: left;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: $hover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
